<template>
    <div class="w-full surface-100 px-1">
		<div class="center px-2  
			xl:px-4 xl:py-3 lg:py-3 md:px-2 md:py-3">
			<div class="banner_app relative overflow-hidden w-full bg-green-100 flex flex-column xl:flex-row lg:flex-row md:flex-row 
				border-round-3xl xl:border-round-3xl lg:border-round-3xl 
				border-ios-3xl xl:border-ios-3xl lg:border-ios-2xl md:border-ios-xl sm:border-ios-xl" >
				<div class="z-0 absolute xl:block lg:block md:block
					w-6 h-full  xl:w-full xl:h-full lg:w-full lg:h-full md:w-full md:h-full sm:w-full sm:h-full 
					right-0 bottom-0 xl:top-0 xl:left-0 lg:top-0 lg:left-0 md:top-0 md:left-0 sm:top-0 sm:right-0
					bg-left xl:bg-left-bottom lg:bg-left-bottom md:bg-left-bottom sm:bg-right
					bg-cover xl:bg-contain lg:bg-contain md:bg-contain sm:bg-contain
					m-0 bg-no-repeat " style="background-image: url('/images/cash.png');" />
				<div class="flex flex-1" />
				<div class="flex flex-1 z-1 
					py-5 px-5 xl:py-8 xl:px-4 lg:py-8 md:py-7 sm:py-6
					">
					<div class="flex flex-column">
						<span class="flex w-8 xl:w-full sm:w-7
							text-green-600 font-bold mb-5 
							text-4xl xl:text-7xl lg:text-6xl md:text-5xl sm:text-4xl">
							{{ content[lang_].title }}
						</span>
						<span class="flex text-green-600 
							w-8 xl:w-full
							text-md xl:text-xl 
							mb-4 xl:mb-5 lg:mb-5 md:mb-4 line-height-2">
							{{ content[lang_].subtitle }}
						</span>
						<div class="w-full flex flex-row">
							<Button :label="content[lang_].button" class="w-full border-round-2xl max-w-20rem" size="large" severity="info" @click="to_transfer()" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
    data(){
        return {
			content: {
				ru: {
					title: 'Первый перевод – за наш счет',
					subtitle: 'Сделайте первый перевод на сумму всего 500 рублей без комиссий',
					button: 'Создать перевод',
				},
				en: {
					title: 'First transfer – at our expense',
					subtitle: 'Make the first transfer for an amount of only 500 rubles without commissions',
					button: 'Create transfer',
				},
			},

        }
    },
	computed: {
        lang_() {
            return (this.$i18n.locale) ? this.$i18n.locale : 'en'
        },  
		isAuth: function () { return this.$store.getters.isAuthenticated },
    },
	methods: {
		to_transfer() {
			if(this.isAuth) {
				this.$router.push({path: '/personal/transfer/create/'})
			} else {
				this.$router.push({path: '/reg/'})
			}
		},
	}
}
</script>